import moment from 'moment';
import { checkOperationForms } from '../../helpers/CheckFunctions.js';
import { formModes, customEventTypes } from '../../../constants.js';
import { eventDispatcher } from '../../../eventDispatcher.js';

export default {
    updateFields(documentData, context) {
        const { formMode } = context;

        const nowDate = new Date();

        const orderDateField = documentData.form.fields.find(f => f.name === 'sx:tlaOrderDate');
        orderDateField.maxValue = moment(nowDate).format("YYYY-MM-DD");

        const dateFrom = documentData.properties['sx:tlaDateFrom'] ? new Date(documentData.properties['sx:tlaDateFrom']) : null;
        const dateTo = documentData.properties['sx:tlaDateTo'] ? new Date(documentData.properties['sx:tlaDateTo']) : null;

        const operationForm = documentData.form.fields.find(f => f.name === 'operationForm');
        operationForm.minDate = dateFrom;
        operationForm.maxDate = dateTo ?? new Date(nowDate.getFullYear(), nowDate.getMonth(), nowDate.getDate());

        const amountCompensationField = documentData.form.fields.find(f => f.name === 'sx:tlaAmountCompensation');
        amountCompensationField.visible = documentData.properties['sx:tlaAmountCompensation'];

        const attachmentsField = operationForm.fields.find(f => f.name === 'sx:attachments');

        attachmentsField.disabled = formMode === formModes.read;

        operationForm.multiple = checkOperationForms(documentData).result;
    },

    checkInputPage(documentData, context) {
        let result = true;
        let errorElementName = '';
        let errorElementId = '';
        let nIndex = 0;

        if (!documentData.properties["sx:tlaOrderDate"]) {
            result = false;
            errorElementName = "sx:tlaOrderDate";
        }
        if (result && !documentData.properties["sx:tlaOrderNumber"]) {
            result = false;
            errorElementName = "sx:tlaOrderNumber";
        }
        if (result && !documentData.properties["assoc:sx:tlaDriver_added"]) {
            result = false;
            errorElementName = "assoc:sx:tlaDriver_added";
        }
        const carInfoForm = documentData.properties["travelLetterCarInfo"][0];
        if (result && !carInfoForm.properties["sx:ciBrandCar"]) {
            result = false;
            errorElementName = "travelLetterCarInfo---0---sx:ciBrandCar";
        }
        if (result && !carInfoForm.properties["sx:ciRegNumerInfo"]) {
            result = false;
            errorElementName = "travelLetterCarInfo---0---sx:ciRegNumerInfo";
        }
        if (result && !carInfoForm.properties["sx:ciReleaseYear"]) {
            result = false;
            errorElementName = "travelLetterCarInfo---0---sx:ciReleaseYear";
        }
        if (result && !carInfoForm.properties["sx:ciEngineType"]) {
            result = false;
            errorElementName = "travelLetterCarInfo---0---sx:ciEngineType";
        }
        if (result && !carInfoForm.properties["sx:ciEngineDisplacement"]) {
            result = false;
            errorElementName = "travelLetterCarInfo---0---sx:ciEngineDisplacement";
        }
        if (result && !carInfoForm.properties["sx:ciCarColor"]) {
            result = false;
            errorElementName = "travelLetterCarInfo---0---sx:ciCarColor";
        }
        if (documentData.properties["operationForm"].length <= 0) {
            result = false;
        }
        if (!result) {
            eventDispatcher.invokeEvent(customEventTypes.onSubformError, {
                subformName: 'travelLetterCarInfo',
                index: 0
            });
        }
        else {
            const formCheckResult = checkOperationForms(documentData);

            if (!formCheckResult.result) {
                result = false;
                errorElementName = formCheckResult.errorElementName;
                errorElementId = formCheckResult.errorElementId;

                eventDispatcher.invokeEvent(customEventTypes.onSubformError, {
                    subformName: 'operationForm',
                    index: formCheckResult.formIndex
                });
            }
        }

        return {
            result,
            errorElementName,
            errorElementId,
            nIndex
        };
    }
}